<app-layout *ngIf="showLayout"></app-layout>
<div [class.impaired]="isImpaired" class="app-container">
<router-outlet></router-outlet>
</div>

<!--<app-inaccessibility></app-inaccessibility>-->
